/* unplugin-vue-components disabled */import script from "./iframePage.vue?vue&type=script&setup=true&lang=js"
export * from "./iframePage.vue?vue&type=script&setup=true&lang=js"

import "./iframePage.vue?vue&type=style&index=0&id=61c5769c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c5769c"]])

export default __exports__